import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppLoaderService } from '../../@theme/shared/services/app-loader/app-loader.service';
import { AccessRightsService } from '../../core/access-rights/access-right.service';
import { AppAuthService } from '../../core/auth/app-auth.service';
import { AppNavigationService } from '../../core/navigation/app-navigation.service';

@Component({
  selector: 'sca-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {


  constructor(
    private _authService: AppAuthService,
    private _accessRights: AccessRightsService,
    private _router: Router,
    private _loader: AppLoaderService,
    private _nav: AppNavigationService
  ) { }


  ngOnInit(): void {
    this._loader.showLoader('Authenticating...Please wait');
    this.completeAuthentication();
  }

  public completeAuthentication(): void {
    // used to read the state from Url and authenticate the user
    this._authService.continueLogin().subscribe(r => {
      this._loader.hideLoader();

      if (!r.isAuthenticated) {
        this._authService.login();
      }
      else {
        // ensure user is allowed to access the app
        this._accessRights.ensureHasAccessRights().subscribe(r => {
          if (!r) {
            this._nav.goToAccessDenied();
          }
          else {
            let requestedUrl = this._authService.getPostLoginRedirectUrl();
            if (requestedUrl) {
              window.location.href = requestedUrl;
              this._authService.clearPostLoginRedirectUrl();
            }
            this._router.navigateByUrl('');
          }
        });
      }
    });
  }
}
